import './NavCardList.css';

function NavCardList({children, numOfCards}) {
  return (
    <div className={`nav_card_list ${numOfCards}`}>
        {children}
    </div>
  )
}

export default NavCardList